export const GlobalColor = "#0f172a";
export const GlobalSecondaryColor = "#475569";
export const GlobalBgColor = "#f8fafc";
export const GlobalCardBg = "#ffffff";
export const GlobalBorderColor = "#e2e8f0";
